import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useEffect, useState } from "react";
import Head from 'next/head';
import Modal from 'react-modal';
import Subscription from "@/components/section/subscription";
import { contact_us as validation } from "@/config/form_validation";
import form_helper from "@/helpers/form_helper";
import { Button, LoadingOverlay, Select, TextInput, Textarea } from "@mantine/core";
import { useForm } from '@mantine/form';
import { LeftRightTextInput, LeftRightTextArea } from "@/components/form";
import { _postURL } from "@/api/index";
import { toast } from "@/libraries/swal";
import { Breadcrumb } from '../components/section/breadcrumb';
import { useRouter } from 'next/router';
import { useScrollLock } from '@mantine/hooks';
import ReCAPTCHA from 'react-google-recaptcha';

export default function Index(props) {
    const { t } = props;
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [buttonIsDisabled, setButtonIsDisabled] = useState(false);

    const [isProcessing, setIsProcessing] = useState(false);
    const [scrollLocked, setScrollLocked] = useScrollLock(false);

    const _openModal = () => {
        setModalIsOpen(true);
    }

    const _closeModal = () => {
        setModalIsOpen(false);
    }

    const currentPage = {
        pageName: 'Contact Us',
        pageLink: useRouter().pathname
    };

    const previousPage = [{}];

    const recaptchaKey = '6Ld2deojAAAAADUwszuuugJqKmbzeAM_aqe9MS3o';

    const router = useRouter();

    // var resolver = form_helper(validation);
    const { getInputProps, onSubmit, isValid } = useForm({
        validateInputOnBlur: true,
        validateInputOnChange: true,
        initialValues: {
            type: 1,
            contact_name: '',
            contact_phone: '',
            contact_email: '',
            subject: '',
            description: '',
            captcha: '',
        },
        // schema: resolver
        validate: {
            type: (inputValue) => (inputValue > 4 && inputValue < 1) && 'Invalid Option',
            contact_name: (inputValue) => inputValue.length < 1 && 'Name must not empty',
            contact_phone: (inputValue) => !(/^(\+?6?01)[02-46-9]-*[0-9]{7}$|^(\+?6?01)[1]-*[0-9]{8}$/.test(inputValue)) && 'Only malaysia phone number is allowed',
            contact_email: (inputValue) => !(/^\S+@\S+$/.test(inputValue)) && 'Invalid email',
            subject: (inputValue) => inputValue.length < 1 && 'Title must not empty',
            description: (inputValue) => inputValue.length < 1 && 'Description must not empty',
            captcha: (inputValue) => (inputValue && inputValue.length < 1) && 'Description must not empty',
        },
        transformValues: ({ type, contact_name, contact_phone, contact_email, subject, description }) => ({
            type,
            email: contact_email,
            name: contact_name,
            phone_number: contact_phone,
            subject,
            content: description
        })
    });

    const submitContactForm = async (formData) => {
        setIsProcessing(true);
        setScrollLocked(true);

        try {
            const response = await _postURL("/api/enquiry", { ...formData });

            if (!_.isObjectLike(response)) throw "Something unexpected happen, please try again later.";

            await toast.success('Thank you! We will contact you shortly.', true, {
                didDestroy: () => { router.reload() }
            });

        } catch (error) {
            toast.error(error)

        } finally {
            setIsProcessing(false);
            setScrollLocked(false);
        }
    }

    // Check for scrollbar when modal is opened or closed
    useEffect(() => {
        const body = document.querySelector('body');
        body.style.overflow = modalIsOpen ? 'hidden' : 'auto';
    }, [modalIsOpen])

    const inputStyles = {
        input: { height: '' },
        label: { fontSize: 22 },
        error: { fontSize: 15 }
    };

    const inputClassNames = {
        root: `login-input-outline col-md-6`,
        input: `form-control rounded-0 shadow-none py-2`,
        error: `text-end`
    };

    return (
        <>
            <Head>
                <title>Contact Us To Grow Better | Ugrado</title>
                <script src="https://www.google.com/recaptcha/api.js" async defer></script>
                <meta name='title' content='Contact Us To Grow Better | Ugrado'></meta>
                <meta itemProp='title' content='Contact Us To Grow Better | Ugrado'></meta>
                <meta property='og:title' content='Contact Us To Grow Better | Ugrado'></meta>
                <meta name='description' content="Get in touch with Ugrado for more info help - increase brand, service quality, ad space, sponsor, iGraming awards, enquiry & others."></meta>
                <meta itemProp='description' content="Get in touch with Ugrado for more info help - increase brand, service quality, ad space, sponsor, iGraming awards, enquiry & others."></meta>
                <meta property='og:description' content="Get in touch with Ugrado for more info help - increase brand, service quality, ad space, sponsor, iGraming awards, enquiry & others."></meta>
                <meta name="keywords" content=""></meta>
            </Head>

            <div className="page-content pt-lg-5 pt-2">
                <section className="contact-us-sec col-lg-9 col-11 mx-auto pt-3">
                    <div className="custom_container2">
                        <div className="row">
                            <div className="col-12">
                                <Breadcrumb
                                    props={ props }
                                    currentPage={ currentPage }
                                    previousPage={ previousPage }
                                />
                                <div className="contact-us-inner">
                                    <h1>{t('Contact_us')}</h1>

                                    <p>We would love to hear from you! Please fill up the contact form below with your
                                        message. Don't forget your name, e-mail, and contact number , we'll get back to you shortly. You can also get in touch with us through social media channels for faster
                                        communication.
                                    </p>

                                    <div className="contact-form">
                                        <form onSubmit={onSubmit((values) => submitContactForm(values))}>
                                            <LoadingOverlay visible={isProcessing} overlayBlur={1} />
                                            <div className="form-group">
                                                <div className="row">
                                                    <div className="col-md-3 d-none d-md-block"></div>
                                                    <div className="col-md-6 col-xs-12 form-title">
                                                        <div className="contact-us-subtitle">
                                                            <h2>{t('What_you_need')}</h2>
                                                        </div>
                                                        <div className="relative">
                                                            <Select
                                                                data={[{ value: 1, label: 'General Enquiry' }, { value: 3, label: 'Sponsorship' }, { value: 5, label: 'Ugrado Awards 2023' }]}
                                                                styles={{
                                                                    item: {
                                                                        '&[data-selected]': {
                                                                          '&, &:hover': {
                                                                            backgroundColor: '#bb9b6a',
                                                                            color: '',
                                                                          },
                                                                        },
                                                                        '&[data-hovered]': {},
                                                                      },
                                                                }}
                                                                { ...getInputProps('type') }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 d-none d-md-block"></div>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <TextInput
                                                    withAsterisk
                                                    type='text'
                                                    name='name'
                                                    placeholder='Name'
                                                    classNames={inputClassNames}
                                                    styles={inputStyles}
                                                    { ...getInputProps('contact_name') }
                                                />
                                                <TextInput
                                                    withAsterisk
                                                    type='text'
                                                    name='email'
                                                    placeholder='Email'
                                                    classNames={inputClassNames}
                                                    styles={inputStyles}
                                                    { ...getInputProps('contact_email') }
                                                />
                                                <TextInput
                                                    withAsterisk
                                                    type='text'
                                                    name='phone_number'
                                                    placeholder='Phone Number'
                                                    classNames={inputClassNames}
                                                    styles={inputStyles}
                                                    { ...getInputProps('contact_phone') }
                                                />
                                            </div>
                                            <div className='row'>
                                                <TextInput
                                                    withAsterisk
                                                    type='text'
                                                    name='subject'
                                                    placeholder='Title'
                                                    classNames={{
                                                        root: `login-input-outline col-md-12`,
                                                        input: `form-control rounded-0 shadow-none py-2`,
                                                        error: `text-end`
                                                    }}
                                                    styles={inputStyles}
                                                    { ...getInputProps('subject') }
                                                />
                                                <Textarea
                                                    withAsterisk
                                                    name='description'
                                                    placeholder='Message'
                                                    classNames={{
                                                        root: `login-input-outline col-md-12`,
                                                        input: `form-control rounded-0 shadow-none py-2`,
                                                        error: `text-end`
                                                    }}
                                                    styles={inputStyles}
                                                    minRows={4}
                                                    { ...getInputProps('description') }
                                                />
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6 col-xs-6 mx-auto form-title">
                                                    <ReCAPTCHA 
                                                        size='normal'
                                                        sitekey={recaptchaKey}
                                                        { ...getInputProps('captcha') }
                                                    />
                                                    {/* <Button type='submit' fullWidth className='btn shadow-none login-btn-pill-bg btn-filled gradient-hover-effect border-0' disabled={!isValid()}>Submit</Button> */}
                                                    <button type='submit' className='btn shadow-none login-btn-pill-bg btn-filled gradient-hover-effect border-0' disabled={!isValid()}>{t('Submit')}</button>
                                                </div>
                                            </div>
                                            {/* <div className="form-group">
                                                <div className="row">
                                                    <div className="col-md-6 col-xs-12 contact-form-input">
                                                        <input className="form-control" type="text" placeholder="name" />
                                                        <div className="form-error-content">Details is compulsory</div>
                                                    </div>
                                                    <div className="col-md-6 col-xs-12 contact-form-input">
                                                        <input className="form-control" type="text" placeholder="email" />
                                                        <div className="form-error-content">Details is compulsory</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="row">
                                                    <div className="col-md-6 col-xs-12 contact-form-input">
                                                        <input className="form-control" type="text" placeholder="phone number" />
                                                        <div className="form-error-content">Details is compulsory</div>
                                                    </div>
                                                    <div className="col-md-6 col-xs-12 contact-form-input">
                                                        <input className="form-control" type="text" placeholder="company name" />
                                                        <div className="form-error-content">Details is compulsory</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="row">
                                                    <div className="col-md-12 col-xs-12">
                                                        <textarea className="form-control" type="text" placeholder="message" rows="5" cols="50"></textarea>
                                                        <div className="form-error-content">Must be at least 20 characters</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="row">
                                                    <div className="col-md-12 col-xs-12 form-title">
                                                        <div className="g-recaptcha pb-4" data-sitekey={recaptchaKey}></div>
                                                        <button type="button" className="btn btn-default">Submit</button>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {/* <section className="contact-us-sec">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="text-box">
                                <h4>{t('Contact_us')}</h4>
                                <p>Have any questions? We would love to hear from you! Just fill up the contact form with
                                    your name, e-mail, and
                                    message, we'll get back to you shortly. You can expect a reply from us within 24 hours
                                    during the week. Else may
                                    get in touch with us through social media channels for faster communication.</p>
                                <button onClick={() => { _openModal() }}>Enquiry Now</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

            {/** Subscription Part */}
            <Subscription {...props} />

            {/** Modal part */}
            {/* <Modal
                isOpen={modalIsOpen}
                onRequestClose={() => { _closeModal() }}
                ariaHideApp={false}
                portalClassName={"contact-modal"}
                className={"contact-modalOpened modal-lg"}
                overlayClassName={"contact-modalOverlayOpened"}
                style={{
                    content: {
                        margin: "50px auto",
                        outline: "none"
                    }
                }}
                aria={{ labelledby: "exampleModalLabel" }}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <span className="close-btn" onClick={() => { _closeModal() }}><img src="/assets//assets/images/close-icon.png" alt="" /></span>
                            <h4>{t('General_enquiry_form')}</h4>
                            <div className="contact-form">
                                <form onSubmit={ onSubmit(_submitContactForm) }>
                                    <LeftRightTextInput
                                        name={t('Your_name')}
                                        showAsterisk={true}
                                        placeholder={'xxxxx xxxxx'}
                                        props={{ ...getInputProps("contact_name") }}
                                    />

                                    <LeftRightTextInput
                                        name={t('Your_phone_no')}
                                        showAsterisk={true}
                                        placeholder={'601XXXXXXXX'}
                                        props={{ ...getInputProps("contact_phone") }}
                                    />

                                    <LeftRightTextInput
                                        name={t('Your_email')}
                                        showAsterisk={true}
                                        placeholder={'xx@gmail.com'}
                                        props={{ ...getInputProps("contact_email") }}
                                    />

                                    <LeftRightTextArea
                                        name={t('Your_questions')}
                                        showAsterisk={true}
                                        props={{ ...getInputProps("description") }}
                                    />

                                    <div className="form-group mb-0">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <Button type="submit" classNames={{root:"btn btn-default"}} disabled={buttonIsDisabled}>{t('Submit')}</Button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal> */}
        </>
    )
}

export async function getStaticProps(data) {
    return {
        props: {
            ...(await serverSideTranslations(data.locale, ['common'])),
        },
    };
}